import React, { useEffect, useRef, useState } from "react";

export const Brands = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="brands" ref={sectionRef} className={visible ? "in-view" : ""}>
      <div className="container">
        <div className="section-title text-center">
          <h2>
            <span>Brands We Deal</span>
          </h2>
          <hr style={{ margin: "0 auto 20px", width: "70px" }} />
          <p>நம்பகமான முன்னணி பிராண்டுகளின் அங்கீகாரம் பெற்ற விற்பனையாளர்</p>
        </div>

        <div className="brands-img-wrap">
          <img
            src="/img/brands.png"
            alt="Brands we deal — Crompton, Orient, Exide, Luminous and more"
            className="brands-combined-img"
          />
        </div>
      </div>
    </section>
  );
};